import { produce } from 'immer';

export function produceMutation<State, CB extends (state: State, ...params: any[]) => any>(
  set: (tx: (state: State) => State) => void,
  transaction: CB,
) {
  const [toBeOmitted, ...restArgs] = [] as unknown as Parameters<CB>;
  return (
    (...params: Parameters<CB>) => {
      set((state) => {
        return produce(state, (stateToMutate: State) => {
          transaction(stateToMutate, ...params);
        });
      });
    }
  ) as unknown as ((...params: typeof restArgs) => ReturnType<CB>);
}
